'use client'

import { useTranslations } from 'next-intl'

import { Button, DropdownMenu, Icon } from '@graftcode/design-system'

import { NOTIFICATION_DRAWER_TEST_IDS } from '@common/common-test-ids.const'

import styles from './NotificationDrawerHeader.module.scss'

type Props = {
  onClose: () => void
  onSettingsClick: () => void
  onClearAll: () => void
}

export function NotificationDrawerHeader({ onClose, onSettingsClick, onClearAll }: Props) {
  const t = useTranslations('notifications')

  const moreMenuItems = [
    {
      type: 'item' as const,
      id: 'clear-all',
      label: t('moreMenu.clearAll'),
      active: true,
      groups: [],
      icon: Icon.DeleteRegular,
      size: 'xs' as const,
    },
  ]

  return (
    <div className={styles.header} data-testid={NOTIFICATION_DRAWER_TEST_IDS.header}>
      <h2 className={styles.title}>{t('title')}</h2>

      <div className={styles.actions}>
        <DropdownMenu
          width="s"
          align="end"
          side="bottom"
          sideOffset={4}
          items={moreMenuItems}
          onItemClick={(itemId) => {
            if (itemId === 'clear-all') onClearAll()
          }}
        >
          <Button iconOnly size="l" variant="ghost" icon={Icon.MoreVerticalRegular} aria-label={t('a11y.more')} />
        </DropdownMenu>

        <Button
          iconOnly
          size="l"
          variant="ghost"
          icon={Icon.SettingsRegular}
          aria-label={t('a11y.settings')}
          onClick={onSettingsClick}
        />

        <Button
          iconOnly
          size="l"
          variant="ghost"
          icon={Icon.DismissRegular}
          aria-label={t('a11y.close')}
          onClick={onClose}
        />
      </div>
    </div>
  )
}
